/**
 * Created by rickborst on 28/02/2017.
 */

import _ from 'lodash';

import Config from 'config';

import * as dataSources from './datasources/';

let instance;

class DataSources {

    /**
     * Constructs the data-sources instance.
     */
    constructor () {

        this._dataSources = {};

        this._createDataSources();
    }

    /**
     * Creates all data-sources.
     *
     * @private
     */
    _createDataSources () {

        _.forOwn(Config.dataSources, this._createDataSource.bind(this));
    }

    /**
     * Creates a data-source by attaching it to the data-sources object.
     *
     * @param {Object} config - Data-source config.
     * @param {string} name - Data-source name.
     * @private
     */
    _createDataSource (config, name) {
        let dataSource = new dataSources[_.capitalize(name)](config, this);

        this._dataSources[name] = dataSource;
    }
}

/**
 * Get singleton instance of datasource.
 *
 * @returns {Object} Datasource instance.
 */
export function getInstance () {

    if (!instance) {
        instance = new DataSources();
    }

    return instance;
}


// WEBPACK FOOTER //
// ./src/js/datasources.js